import type { Incident, IncidentStatus } from '../../incidents/types/incident.types'
import type { StatCard } from '../types/liveOps.types'

export const ACTIVE_ALERT_STATUSES = new Set<IncidentStatus>(['NEW', 'IN_PROGRESS', 'ACKNOWLEDGE'])

export function isToday(iso: string, now: Date): boolean {
  const d = new Date(iso)
  return (
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  )
}

export function computeKpis(incidents: Incident[], now: Date): StatCard[] {
  const openTasks = incidents.filter(
    (i) => i.status === 'IN_PROGRESS' || i.status === 'ACKNOWLEDGE',
  ).length
  const activeAlerts = incidents.filter(
    (i) => i.priority === 'CRITICAL' && ACTIVE_ALERT_STATUSES.has(i.status),
  ).length
  const incidentsToday = incidents.filter((i) => isToday(i.created_at, now)).length

  return [
    { label: 'Open Tasks', value: String(openTasks), icon: 'activity', color: 'text-blue-500' },
    { label: 'Active Alerts', value: String(activeAlerts), icon: 'alert-circle', color: 'text-red-500' },
    { label: 'Incidents Today', value: String(incidentsToday), icon: 'clock', color: 'text-purple-500' },
  ]
}

export function formatClockTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}
